<template>
  <span class="Num num-f">
    <!-- {{ $f.numFormat(value[0].children) }} -->
    {{ $f.numFormat(slots.default()[0].children) }}
  </span>
</template>

<script setup>

const props = defineProps({

})
const slots = useSlots()
// const value = $computed(() => slots.default())
// console.log('value', value)

onBeforeMount(() => {
})
</script>

<style lang="scss">
.Num {
}
</style>
